"use strict";
angular.module('newsMonitorRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('front.plan.realtimeclues.suddenclues.newsmonitor.weibo', {
                url: '/weibo',
                views: {
                    'main@front.plan.realtimeclues.suddenclues.newsmonitor': {
                        templateUrl: './planningCenter/realTimeClues/suddenClues/newsMonitor/weibo/weiboMonitor_tpl.html',
                        controller: 'weiboMonitorController'
                    }
                }
            });
    }]);